// extracted by mini-css-extract-plugin
export default {"centered-container":"mfa_centered-container__PLlGL","boxStyle":"mfa_boxStyle__v6SgZ","card":"mfa_card__Szb2n"};